/*
 * Author: Roger
 * File Created: Wednesday, 24-09-04 06:10 pm
 * Last Modified: Wednesday, 25-04-09 06:14 pm, by Harper Yan
 */

/*
 * Author: Dw
 * File Created: Monday, 24-08-05 04:16 pm
 * Last Modified: Wednesday, 24-09-04 06:08 pm, by Roger
 */
import { useTranslation } from 'next-i18next';
import { motion } from 'framer-motion';
import { Stack } from '@mui/material';
import { Flex } from '@ucard/ds/containers';
import { useScreenSize } from '@ucard/ds/utils';
import SectionBox from '@/components/LandingContainer/SectionBox';
import useLanguage from '@/hooks/useLanguage';
import { products } from './config';
import Product from './Product';
import { SectionTitle } from './style';
const Products = () => {
  const isXsScreen = useScreenSize('xs');
  const {
    t
  } = useTranslation('home');
  const offset = isXsScreen ? 15 : 100;
  const {
    curLocale
  } = useLanguage();
  const symbol = curLocale === 'zh' && isXsScreen ? '，' : '';
  return <SectionBox layerSx={{
    background: '#1A1A1A',
    position: 'relative'
  }} data-sentry-element="SectionBox" data-sentry-component="Products" data-sentry-source-file="index.tsx">
      <Flex justifyContent="center" pt={[5, 10]} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <motion.div initial={{
        opacity: 0,
        y: offset
      }} style={{
        textAlign: 'center'
      }} transition={{
        duration: 1
      }} whileInView={{
        opacity: 1,
        y: 0
      }} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
          <SectionTitle data-sentry-element="SectionTitle" data-sentry-source-file="index.tsx">
            {t('products.title.0')}
            {symbol}
          </SectionTitle>
          <SectionTitle data-sentry-element="SectionTitle" data-sentry-source-file="index.tsx">{t('products.title.1')}</SectionTitle>
        </motion.div>
      </Flex>
      <Stack gap={7.5} pb={[5, '100px']} data-sentry-element="Stack" data-sentry-source-file="index.tsx">
        {products.map((product, index) => <Product key={index} {...product} />)}
      </Stack>
    </SectionBox>;
};
export default Products;